import Memes from "./components/Memes";
import StoriesController from "./components/stories/StoriesController";
import Popups from "./components/Popups";
import Modals from "./components/Modals";
import Media from "./components/Media";
import Comments from "./components/Comments";
import Sliders from "./components/Sliders";
import "./misc/misc";

Memes.initModule();
Popups.initModule();
Modals.initModule();
Media.initModule();
Comments.initModule();
Sliders.initModule();

if(jQuery('[data-stories-wrapper]').length > 0) {
    new StoriesController();
}